<template>
  <div class="wrapper">
    <div class="showBar">
      <el-button type="primary" size="mini" @click="showDialog"
        >选择学生</el-button
      >
      &ensp;
      <el-tag
        :key="item.id"
        v-for="(item, idx) in studentList"
        @close="deleteStudent(idx)"
        closable
        size="small"
      >
        {{ item.userName }}
      </el-tag>
    </div>
    <el-dialog
      title="选择分组"
      :visible.sync="dialogIfShow"
      width="70%"
      :append-to-body="true"
    >
      <div class="totalContainer">
        <div class="groupSide">
          <div class="title">考生管理</div>
          <div style="margin: 0 15px">
            <mytree
              :treeData="studentGroup"
              :searchInput="true"
              @eventUp="studentGroupEvent"
            ></mytree>
          </div>
        </div>
        <div class="studentSide">
          <div class="searchBar">
            <el-pagination
              small
              layout="prev, pager, next"
              :current-page.sync="searchCondition.jumpPage"
              :page-size.sync="searchCondition.pageSize"
              :total="searchCondition.total"
              @current-change="searchStudent"
            >
            </el-pagination>
            <el-input
              placeholder="请输入内容"
              size="small"
              v-model="searchCondition.userName"
              style="width: 40%"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchStudent"
              ></el-button>
            </el-input>
          </div>
          <div class="studentContainer">
            <div
              class="studentCell"
              v-for="item in studentSearchList"
              :style="{
                borderColor:
                  studentSearchChosenList.findIndex(
                    (stu) => stu.id == item.id
                  ) > -1
                    ? '#36aafd'
                    : '',
              }"
              @click="studentAppend(item)"
              :key="item.id"
            >
              <el-image
                class="avatar"
                fit="contain"
                :src="item.faceUrl"
              ></el-image>
              <div class="detailBox">
                <div class="name">{{ item.userName }}</div>
                <div class="greyFont">手机:{{ item.mobile || "-" }}</div>
              </div>
            </div>
            <div class="emptyBox" v-if="studentSearchList.length == 0">
              该筛选条件下无考生
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <span style="float: left; line-height: 40px">
          已选{{ studentSearchChosenList.length }}位考生</span
        >

        <el-button size="small" @click="dialogIfShow = false">取消</el-button>
        <el-button size="small" type="primary" @click="confirmStudentChosen"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getStudentGroup,
  deleteStudentGroup,
  editStudentGroup,
  createStudentGroup,
  getStudentList,
  moveStudentGroup,
} from "@/api/examination/student.js";
import mytree from "@/component/tree/mytree.vue";
export default {
  props: {
    studentList: Array,
  },

  data() {
    return {
      studentGroup: [],
      studentSearchList: [],
      studentSearchChosenList: [],
      searchCondition: {
        jumpPage: 1,
        pageSize: 18,
        groupId: 0,
        total: 0,
        userName: "",
      },
      dialogIfShow: false,
    };
  },
  computed: {},
  components: {
    mytree,
  },
  created() {},
  mounted() {
    this.getStudentGroup();
    this.studentSearchChosenList = [...this.studentList];
  },
  methods: {
    studentGroupEvent(option) {
      switch (option.type) {
        case "select":
          if (this.searchCondition.groupId == option.value.id) {
            break;
          } else {
            this.searchCondition.groupId = option.value.id;
            this.searchStudent();
          }

          break;

        default:
          break;
      }
    },
    deleteStudent(idx) {
      this.$emit("eventUp", {
        type: "delete",
        value: idx,
      });
    },
    confirmStudentChosen() {
      // this.studentList = [...this.studentSearchChosenList];
      this.$emit("eventUp", {
        type: "confirm",
        value: this.studentSearchChosenList,
      });
      this.dialogIfShow = false;
    },
    studentAppend(item) {
      let theIdx = this.studentSearchChosenList.findIndex(
        (stu) => stu.id == item.id
      );
      if (theIdx < 0) {
        this.studentSearchChosenList.push(item);
      } else {
        this.studentSearchChosenList.splice(theIdx, 1);
      }

      this.$forceUpdate();
    },
    showDialog() {
      this.searchStudent();
      this.studentSearchChosenList = [...this.studentList];
      this.dialogIfShow = true;
    },

    searchStudent() {
      getStudentList(this.searchCondition).then((data) => {
        this.studentSearchList = data.records;
        this.searchCondition.total = data.total;
      });
    },
    getStudentGroup() {
      getStudentGroup().then((data) => {
        data.unshift({
          id: 0,
          title: "所有分类",
          parentId: 0,
          children: [],
        });
        this.studentGroup = data;
      });
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  .showBar {
    padding: 5px 0 5px 5px;
    line-height: 32px;
    border: 1px solid #36aafd;
    border-radius: 5px;
    width: 80%;
    .el-button--small,
    .el-tag {
      margin-right: 10px;
    }
  }
}
.totalContainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .groupSide {
    flex: 1;
    border: 1px solid #ccc;
    border-radius: 5px;
    .title {
      line-height: 36px;
      border-bottom: 1px solid #ccc;
      padding: 0 15px;
    }
  }
  .studentSide {
    margin-left: 20px;
    flex: 3;
    .searchBar {
      display: flex;
      justify-content: space-between;
      padding-bottom: 5px;
    }
    .studentContainer {
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 15px 0 5px 0;
      display: flex;
      flex-wrap: wrap;
      .studentCell:first-child {
        margin-left: 2.5%;
      }
      .studentCell + .studentCell {
        margin-left: 2.5%;
      }
      .studentCell {
        display: flex;
        justify-content: space-between;
        padding: 8px 5px;
        width: 30%;
        border: 1px solid #ccc;
        border-radius: 4px;
        margin-bottom: 8px;
        cursor: pointer;
        .avatar {
          width: 90px;
          height: 50px;
          width: 30%;
        }
        .detailBox {
          flex: 1;
        }
      }
      .emptyBox {
        height: 300px;
        line-height: 300px;
        text-align: center;
        width: 100%;
      }
    }
  }
}
/deep/ .el-dialog__body {
  padding: 0 15px !important;
}
/deep/ .el-dialog {
  margin-top: 5vh !important;
  overflow: hidden !important;
}
/deep/ .el-dialog__wrapper {
}
</style>
